import React from 'react'
import TestimonialsSlide from './TestimonialsSlide'
import urls from '@/utils/urls/urls';
import { Metadata } from 'next';
import cl from '@/utils/console/cl';
import AnimationWrapper from '../AnimationWrapper/AnimationWrapper';

export const metadata: Metadata = {
    title: 'Testimonials',
    description: 'Testimonials',
}

const Testimonial = async () => {
    const res = await fetch(urls?.testimonial);
    const data = await res.json();
    const testimonials = Array.isArray(data?.data) ? data?.data : [];
    // cl("testimonials", testimonials);
    return (
        <div className="testimonial-area tm-bg pt-80 pb-60">
            <div className="container">
                <div className="row">
                    <div className="col-lg-4">
                        <AnimationWrapper animation="fade-left">
                            <div className="site-heading wow fadeInDown" data-wow-delay=".25s">
                                <span className="site-title-tagline">
                                    <i className="fas fa-solar-panel" /> Testimonials
                                </span>
                                <h2 className="site-title text-white">
                                    What Our Client <span>Say's</span> about us
                                </h2>
                                <p className="text-white">
                                    We always feel heard and understood. The team’s commitment to listening to our needs and incorporating our feedback has truly set them apart. They consistently deliver outstanding results that align perfectly with our vision.
                                </p>
                                <a href="contact" className="theme-btn mt-30">
                                    Know More <i className="fas fa-arrow-right" />
                                </a>
                            </div>
                        </AnimationWrapper>
                    </div>
                    <div className="col-lg-8">
                        <AnimationWrapper animation="fade-right">
                            <TestimonialsSlide testimonials={testimonials} />
                        </AnimationWrapper>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Testimonial
